var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.465,24.931a5.465,5.465,0,1,1,5.465-5.465A5.465,5.465,0,0,1,18.465,24.931Zm0-9.564a4.1,4.1,0,1,0,4.1,4.1A4.1,4.1,0,0,0,18.465,15.366Z",
    transform: "translate(-4.119 -4.436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.769,22.782,20,21.013V18h1.366v2.453l1.366,1.366Z",
    transform: "translate(-6.337 -5.703)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,4.733A1.366,1.366,0,0,0,19.03,3.366H16.3V2H14.931V3.366H9.465V2H8.1V3.366H5.366A1.366,1.366,0,0,0,4,4.733V18.4a1.366,1.366,0,0,0,1.366,1.366H8.1V18.4H5.366V4.733H8.1V6.1H9.465V4.733h5.465V6.1H16.3V4.733H19.03v4.1H20.4Z",
    transform: "translate(-1.267 -0.634)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTimer);
export default __webpack_public_path__ + "static/media/calendar-timer.79b7e9d5bcc722db7cfaa2fe3f58d38b.svg";
export { ForwardRef as ReactComponent };